import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import $ from 'jquery'
async function downloadHtmlToPdf (dom, title, domWidth, domHeight) {
    // const width = dom[0].scrollWidth
    const window_height = window.screen.availHeight //窗口高度
    html2Canvas(dom[0], {    // 表格id，这个id很重要，一旦填写错了或者不填写就会报错
        allowTaint: true,
        useCORS: true,
        height: domHeight < window_height ? window_height : domHeight, //canvas画布的具体高度
        width: domWidth,
        windowWidth: domWidth,
        windowHeight: domHeight < window_height ? window_height : domHeight,
        // scrollX: 5,
        // scrollY: 5,
        //     scale: 1, //设置放大的倍数
    }).then(function (canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        let leftHeight = contentHeight
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        //    参数：方向（l：横向，p：纵向）| 测量单位（"pt"，"mm", "cm", "m", "in" or "px"）| 格式（默认a4，也可通过大小数组[595.28, 841.89]）
        if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
            console.log(pageData)
        } else {
            while (leftHeight > 0) {
                PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                leftHeight -= pageHeight
                position -= 841.89
                if (leftHeight > 0) {
                    PDF.addPage()
                }
            }
        }
        if (i != 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            position -= 841.89
            PDF.addPage()
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        }
        PDF.save(title + '.pdf')
        return Promise.resolve()
    }).catch((error) => {
        return Promise.reject()
    }).finally((e) => {
    })
}

export default downloadHtmlToPdf
